module.exports = __webpack_public_path__ + "img/im_logo.7cf133f5.png";